import { breakpoints, colors, radius, shadows, borders, space, zIndex } from '@airwallex/global';
import { navTheme as nav } from './components/nav';
import { timelineTheme as timeline } from './components/timeline';
import { alertTheme as alert } from './components/alert';
import { getComponentTheme } from './components'; // nothing language/character-specific

export var baseTheme = {
  breakpoints: breakpoints,
  colors: colors,
  radius: radius,
  borders: borders,
  shadows: shadows,
  space: space,
  zIndex: zIndex,
  nav: nav,
  alert: alert,
  timeline: timeline,
  button: getComponentTheme({
    componentType: 'button'
  }),
  textInput: getComponentTheme({
    componentType: 'textInput'
  })
};